import StatisticsDataSource from 'store/modules/dashboards/dataGetter/dataSources/StatisticsDataSource';
import OrdersDataSource from 'store/modules/dashboards/dataGetter/dataSources/OrdersDataSource';
import OrderPeriodsAndStatDataSource
  from 'store/modules/dashboards/dataGetter/dataSources/OrderPeriodsAndStatDataSource';

function getDsMap (dashboard, dashboardParams, profiles, metrics) {
  const constructorArgs = {
    dashboard,
    dashboardParams,
    profiles,
    metrics
  };

  return {
    statistics: new StatisticsDataSource(constructorArgs),
    orders: new OrdersDataSource(constructorArgs),
    ordersAndStat: new OrderPeriodsAndStatDataSource(constructorArgs)
  };
}

export class DashboardDataSource {
  constructor (dashboard, dashboardParams, profiles, metrics) {
    this.dsMap = getDsMap(dashboard, dashboardParams, profiles, metrics);
  }

  fetchData (dsType, dsParams, dashboardAccounts, dashboardProjects, withVat, ignoreCache = false) {
    return this.dsMap[dsType].fetch(
      dsParams,
      {
        dashboardAccounts,
        dashboardProjects
      },
      withVat,
      ignoreCache
    );
  }
}
